import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

type NewClientEntry = {
	name?: string | null;
	phone?: string | null;
	street?: string | null;
	isStore?: boolean | null;
};

type NewClientsTableProps = {
	clients?: NewClientEntry[];
};

export function NewClientsTable({ clients = [] }: NewClientsTableProps) {
	return (
		<div className="overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead className="w-[280px]">Nome</TableHead>
						<TableHead className="w-[120px]">Telefone</TableHead>
						<TableHead className="w-[240px]">Rua</TableHead>
						<TableHead className="w-[60px] text-center">Loja</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{clients.map((client) => {
						const rowKey = `${client.name ?? "client"}-${
							client.phone ?? "phone"
						}-${client.street ?? "street"}`;

						return (
							<TableRow key={rowKey}>
								<TableCell>{client.name ?? "-"}</TableCell>
								<TableCell>{client.phone ?? "-"}</TableCell>
								<TableCell>{client.street ?? "-"}</TableCell>
								<TableCell className="text-center">
									{client.isStore ? "X" : ""}
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</div>
	);
}
